export const STORAGE_FAILED_REASONS = [
  { name: "Unable to Contact Customer", value: "unable_to_contact_customer" },
  { name: "Customer Refused Package", value: "customer_refusal" },
  { name: "Items Not Staged", value: "items_not_staged" },
  { name: "Unable to Park Vehicle ", value: "unable_to_park_vehicle" },
  { name: "Unsafe Drop Off Area", value: "unsafe_drop_off_area" },
  { name: "Other", value: "other" },
];

export const FULFILLMENT_FAILED_REASONS = [
  {
    name: "Damaged items",
    value: "damaged_items",
  },
  {
    name: "Damaged upon receiving",
    value: "damaged_upon_receiving",
  },
  {
    name: "Business is closed",
    value: "business_is_closed",
  },
  {
    name: "Business Closed - Weekend",
    value: "business_is_closed_weekend",
  },
  {
    name: "Business Closed - Holiday",
    value: "business_is_closed_holiday",
  },
  {
    name: "Order missing",
    value: "order_missing",
  },
  {
    name: "Customer refused",
    value: "customer_refused",
  },
  {
    name: "Customer unavailable",
    value: "customer_unavailable",
  },
  {
    name: "Customer Moved",
    value: "customer_moved",
  },
  {
    name: "Address",
    value: "address",
  },
  {
    name: "Address - Missing House/Unit number",
    value: "address_missing_house_unit_number",
  },
  {
    name: "Address - Missing Buzz Code",
    value: "address_missing_buzz_code",
  },
  {
    name: "Address - Map Location",
    value: "address_map_location",
  },
  {
    name: "Address - Unable to access",
    value: "address_unable_to_access",
  },
  {
    name: "Address - Gated Community",
    value: "address_gated_community",
  },
  {
    name: "Address - Unable to drop",
    value: "address_unable_to_drop",
  },
  {
    name: "Unable to complete route",
    value: "unable_to_complete_route",
  },
  {
    name: "Car Accident/Breakdown",
    value: "car_accident_breakdown",
  },
  {
    name: "Weather",
    value: "weather",
  },
  {
    name: "Road Closure",
    value: "road_closure",
  },
  {
    name: "Does not belong to route",
    value: "does_not_belong_to_route",
  },
  {
    name: "Route Stolen",
    value: "route_stolen",
  },
  {
    name: "Lost by warehouse",
    value: "lost_by_warehouse",
  },
  {
    name: "Lost on road",
    value: "lost_on_road",
  },
  {
    name: "Return to Sender",
    value: "return_to_merchant",
  },
  {
    name: "Return to Origin Facility",
    value: "return_to_origin_facility",
  },
  {
    name: "All items not staged",
    value: "all_items_not_staged",
  },
  {
    name: "Other",
    value: "other",
  },
];
